import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to top on every route change.
 *
 * Why we need it: React Router preserves scroll position across `<Link>`
 * navigations. That's a footgun for a content-heavy site — someone reading
 * the footer of `/food`, tapping "About", lands halfway down the About page.
 *
 * Behaviour:
 *  · plain path change  → jump to top (no smooth scroll — instant feels correct)
 *  · hash present (#id) → let the browser handle the anchor, don't override
 *  · same-path re-nav   → no-op (useEffect deps unchanged)
 *
 * Mount ONCE inside <BrowserRouter> and above <Routes>.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
}
